import FDictionary from '../__select';
import Form from './Form';

export default class FDictionaryRoomType extends FDictionary {
  dictionary = 'roomType';

  permissionAdd = [115];

  addForm() {
    const item = new Form();
    item.init()
      .then();
    return item;
  }
}
